module.exports = __webpack_public_path__ + "static/media/tenopy-brand.30688e6c.svg";